<template>
  <v-card id="paymentMethodListItem" class="d-flex align-center" tile flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start pa-0">
          <PaymentCardField v-if="card" :card="card" class="mx-0" />
        </v-col>
        <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start pa-0">
          <div v-if="card" class="body-text-xs">Expires:{{ `${card.exp_month}/${card.exp_year}` }}</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import PaymentCardField from "./PaymentCardField";

  export default {
    name: "PaymentMethodListItem",

    props: ["paymentMethod"],

    components: { PaymentCardField },

    computed: {
      card() {
        return this.paymentMethod ? this.paymentMethod.card : undefined;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Payment/PaymentMethodListItem.vue